export function expandAbbrWeek(str) {
  const nums = str.split("W");

  return `Week ${nums[1]}, ${nums[0]}`;
}

export function abbreviateWeek(week, year) {
  return `${year}W${week}`;
}
